function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
const TheaterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M953.379 519.281v-481.633c-132.698-23.866-285.446-37.513-441.379-37.513s-308.678 13.646-457.106 39.809l15.726-2.296v481.633c132.452-15.741 285.867-24.722 441.379-24.722 155.51 0 308.922 8.981 459.746 26.452l-18.367-1.73z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M35.31 43.757l-35.31 6.232v477.325l35.31-4.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M988.69 43.757v479.409l35.31 4.149v-477.325z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M300.138 812.551c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M423.724 864.969c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 88.276h105.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M512 706.62c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M441.379 812.551c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M229.517 706.62c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M882.759 864.969v88.276h105.931v-88.276c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M105.931 759.038v19.421c21.853 4.687 40.273 16.945 52.797 33.837l0.169 0.237c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.421c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M282.483 864.969c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 88.276h105.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M564.966 864.969c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 88.276h105.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M370.759 706.62c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M865.103 812.551c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M35.31 953.245h105.931v-88.276c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M847.448 864.969c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 88.276h105.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1006.345 988.556h-988.69c-9.751 0-17.655 7.904-17.655 17.655s7.904 17.655 17.655 17.655v0h988.69c9.751 0 17.655-7.904 17.655-17.655s-7.904-17.655-17.655-17.655v0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M794.483 706.62c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M582.621 812.551c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M706.207 864.969c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 88.276h105.931z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M653.241 706.62c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M723.862 812.551c12.693-17.13 31.113-29.387 52.385-33.97l0.58-0.105v-19.438c0-29.252-23.713-52.966-52.966-52.966s-52.966 23.713-52.966 52.966v0 19.421c21.855 4.692 40.276 16.956 52.797 33.854l0.169 0.238z"
}));
export default TheaterIcon;
